<a
  class="capra-button {{ variant }} link"
  [attr.aria-label]="ariaLabel"
  [ngClass]="['size-' + size, 'color-' + color, 'location-icon-' + iconLocation]"
  [class.with-icon]="!!icon"
  [href]="href"
  [class.disabled]="disabled"
  data-test="capra-button-link"
  rel="noopener noreferrer"
  [target]="target"
>
  <capra-icon *ngIf="!!icon" [icon]="icon"></capra-icon>
  {{ text }}
</a>
